import headerImgEn from "assets/images/v126/header-en.webp"
import infoImgEn from "assets/images/v126/info-en.webp"

export const v126ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
